import { z } from 'zod'
import { SignalNoticeTypes } from 'applications/signal/constants';

export const NotificationSettingPostFormSchema = z.object({
  name: z.string().min(1, "設定名は必須です").max(100, "設定名は100文字以下でなければなりません"),
  minThreshold: z.preprocess(
    (val) => (typeof val === 'number' ? val.toString() : val),
    z.string()
    .nonempty("最小閾値は必須です")
    .refine(
      (val) => /^\d+(\.\d{1,2})?$/.test(val.toString()),
      { message: "小数点以下は2桁までにしてください" }
    )
    .transform(val => Number(val))
    .pipe(
      z.number()
        .min(0.1, "最小閾値は0.1以上でなければなりません")
        .max(99.99, "最小閾値は99.99以下でなければなりません")
    )
  ),
  maxThreshold: z.preprocess(
    (val) => (typeof val === 'number' ? val.toString() : val),
    z.string()
    .nonempty("最大閾値は必須です")
    .refine(
      (val) => /^\d+(\.\d{1,2})?$/.test(val.toString()),
      { message: "小数点以下は2桁までにしてください" }
    )
    .transform(val => Number(val))
    .pipe(
      z.number()
        .min(0.1, "最大閾値は0.1以上でなければなりません")
        .max(99.99, "最大閾値は99.99以下でなければなりません")
     )
  ),
  noticeType: z.number()
    .min(SignalNoticeTypes[0].id, "通知タイプは必須です")
    .max(SignalNoticeTypes[SignalNoticeTypes.length - 1].id, "通知タイプの値が不正です"),
}).refine(
  (data) => data.maxThreshold > data.minThreshold,
  {
    message: "最大閾値は最小閾値より大きくなければなりません",
    path: ["maxThreshold"],
  }
);

export type NotificationSettingPostFormData = z.infer<typeof NotificationSettingPostFormSchema>
